import React, { useEffect, useState } from "react";
import { Row, Col, Checkbox, Select } from "antd";
import { FormContentWrapper, FormWrapper, Title } from "./styles";
import FormInput from "../../components/Input";
import Button from "../../components/Button";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mixpanel } from "./../../Mixpanel";
import { useHistory } from "react-router-dom";
import { HeirsEmailUrl } from "../../utils/constants";
import { SelectWrapper } from "../../components/Input/style";

const Form = () => {
  const { Option } = Select;
  const [value, setValue] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    destination: [
      "nimiweremi.selekere@heirslifeassurance.com",
      "wecare@heirsgeneralinsurance.com",
    ],
    message: "",
    plan: "TEF",
  });
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: [],
    plan: "TEF",
  });

  const [isChecked, setChecked] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });
  let history = useHistory();

  useEffect(() => {
    if (
      isChecked &&
      value.firstName &&
      value.lastName &&
      value.email &&
      value.phoneNumber &&
      value.message &&
      !error.firstName &&
      !error.lastName &&
      !error.email &&
      !error.phoneNumber
      // !error.message
    ) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [value, error, isChecked]);

  const handleServerResponse = (ok, msg) => {
    if (ok) {
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: msg },
      });
      Array.from(document.querySelectorAll("input")).forEach(
        (input) => (input.value = "")
      );
      Array.from(document.querySelectorAll("textarea")).forEach(
        (textarea) => (textarea.value = "")
      );
      setIsDisabled(false);
    } else {
      setStatus({
        info: { error: true, msg: msg },
      });
    }
  };

  const handleSubmit = (e) => {
    Mixpanel.track("Send Message");
    const data = { ...value };
    e.preventDefault();
    setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));
    axios({
      method: "POST",
      url: `${HeirsEmailUrl}/email/others`,
      data: data,
    })
      .then((response) => {
        if (response.status === 200) {
          handleServerResponse(true, response.data.message);
          // setTimeout(() => {
          //   history.push("/flexi-motor");
          // }, 5000);
        } else {
          handleServerResponse(false, response.data.message);
        }
      })
      .catch((error) => {
        handleServerResponse(false, "An internal error occured");
      });
  };

  const handleNameChange = (e) => {
    const val = e.target.value;
    if (!/[^a-zA-Z]/.test(val)) {
      setValue({
        ...value,
        [e.target.name]: val,
      });
    } else {
      setValue({
        ...value,
        [e.target.name]: "",
      });
    }

    if (val.length < 3) {
      setError({
        ...error,
        [e.target.name]: "name cannot be less than three characters",
      });
    } else {
      setError({
        ...error,
        [e.target.name]: "",
      });
    }
  };

  const handleSelect = (val) => {
    setValue({ ...value, message: val });
  };

  const handleEmailChange = (e) => {
    const reg = /\S+@\S+\.\S+/;
    const val = e.target.value;
    setValue({ ...value, email: val });

    if (reg.test(String(val).toLowerCase())) {
      setError({ ...error, email: "" });
    } else {
      setError({
        ...error,
        email: "please enter a valid email address",
      });
    }
  };

  const handlePhoneNumberChange = (e) => {
    const val = e.target.value;
    const reg = /^[0-9]+$/;

    if (reg.test(val)) {
      setValue({ ...value, phoneNumber: val });
    }

    if (val.length < 11 || val.length > 11) {
      setError({
        ...error,
        phoneNumber:
          "your phone number should not be more or less than 11 digits",
      });
    } else {
      setError({
        ...error,
        phoneNumber: "",
      });
    }
  };

  return (
    <FormWrapper id="tef">
      <FormContentWrapper>
        <Title>
          Register now to sign up for your preferred package and activate the
          #SimpleLife
        </Title>
        {/* <Button style={{ marginBottom: "30px" }}>
          <a
            target="_blank"
            href="https://mcusercontent.com/b36906121853fa557377fbd4a/files/fa161389-06f2-7b0f-5b5d-757d904d7167/HILxHLAxTEF_Insurance_Package_Brochure.pdf"
          >
            {" "}
            Download Brochure{" "}
          </a>
        </Button> */}

        <Row gutter={[32, 16]}>
          <Col span={24} md={12}>
            <FormInput
              placeholder="First name"
              name="firstName"
              type="text"
              onChange={handleNameChange}
              value={value.firstName}
            />
            <small>{error.firstName}</small>
          </Col>
          <Col span={24} md={12}>
            <FormInput
              placeholder="Last name"
              name="lastName"
              type="text"
              onChange={handleNameChange}
              value={value.lastName}
            />
            <small>{error.lastName}</small>
          </Col>
          <Col span={24} md={12}>
            <FormInput
              placeholder="Email Address"
              name="email"
              type="email"
              onChange={handleEmailChange}
              value={value.email}
            />
            <small>{error.email}</small>
          </Col>
          <Col span={24} md={12}>
            <FormInput
              placeholder="Phone number"
              name="phoneNumber"
              type="text"
              onChange={handlePhoneNumberChange}
              value={value.phoneNumber}
            />
            <small>{error.phoneNumber}</small>
          </Col>
          <Col span={24}>
            <label>What product are you interested in?</label>
            <SelectWrapper
              mode="multiple"
              placeholder="Select product"
              optionLabelProp="label"
              onChange={handleSelect}
              value={value.message}
            >
              <Option
                value="Package 1 (Cost: 12,750 for 3 employees/ per year) "
                label="Package 1 (Cost: 12,750 for 3 employees/ per year)"
              />
              <Option
                value="Package 2 (Cost: N25,750 for 3 employees / per year)"
                label="Package 2 (Cost: N25,750 for 3 employees / per year)"
              />
              <Option value="Motor Insurance" label="Motor Insurance" />
              {/* <Option
                value="Entrepreneur’s plan (Investment + Life Insurance)"
                label="Entrepreneur’s plan (Investment + Life Insurance)"
              /> */}
            </SelectWrapper>
            <small>{error.date}</small>
          </Col>
          <Col span={24}>
            <Checkbox
              checked={isChecked}
              onChange={() => setChecked(!isChecked)}
            >
              I agree to the company’s{" "}
              <Link to="/terms">Terms and Conditions</Link>
            </Checkbox>
          </Col>
        </Row>
      </FormContentWrapper>
      <Button onClick={handleSubmit} disabled={isDisabled}>
        Subscribe
      </Button>

      {status.info.error && (
        <div className="error">Error: {status.info.msg}</div>
      )}
      {!status.info.error && status.info.msg && <p>{status.info.msg}</p>}
    </FormWrapper>
  );
};

export default Form;
